<template>
    <div class="review">
        <div>
            <button class="back_button mt-2" @click="routeToDashboard()">Back to Dashboard</button>
        </div>
        <div class="flex space-between mt-1">
            <div>
                <p class="heading">{{ heading }}</p>
            </div>
           <pagination  :total="totalData" ref="paginationRef" @changePage="getReviewList()"/>
            <div class="flex filters">
                <small
                    :class="{ active: filter == '' }"
                    @click="getReviewByFilters('')"
                >
                    Most recent
                </small>
                <small
                    :class="{ active: filter == '5' }"
                    @click="getReviewByFilters('5')"
                    >5 Stars</small
                >
                <small
                    :class="{ active: filter == '4' }"
                    @click="getReviewByFilters('4')"
                    >4 Stars</small
                >
                <small
                    :class="{ active: filter == '3' }"
                    @click="getReviewByFilters('3')"
                    >3 Stars</small
                >
                <small
                    :class="{ active: filter == '2' }"
                    @click="getReviewByFilters('2')"
                    >2 Stars</small
                >
                <small
                    :class="{ active: filter == '1' }"
                    @click="getReviewByFilters('1')"
                    >1 Stars</small
                >
            </div>
        </div>
        <div>
            <review-list :data="reviewData"  />
        </div>
        <!-- <edit-comment ref="editCommentRef" /> -->
        <!-- <reply-comment ref="replyCommentRef" /> -->
    </div>
</template>

<script>
import editComment from "./components/edit-comment.vue";
import replyComment from "./components/reply-comment.vue";
import reviewList from "./components/review-list.vue";
import API_URL from "../../../helpers/apiUrls";
import accessToken from "../../../helpers/accessToken";
import pagination from "../Common/pagination.vue";
export default {
    name: "review",
    components: {
        "edit-comment": editComment,
        "reply-comment": replyComment,
        "review-list": reviewList,
        "pagination" : pagination
    },
    data() {
        return {
            userimage: require("./../../../assets/DummyAvatar.png"),
            reviewData: null,
            heading: null,
            totalData:0,
            filter: "",
            page: 1,
        };
    },
     computed : {
        postDetails() {
            return this.$store.getters['dashboardStore/GET_TOGGLE_STATE'];
        }
    },
    mounted() {
        this.getReviewList();
    },
    methods: {
         routeToDashboard(){
         this.$router.push({ name : 'dashboard' })
        },
        showCommentDialog() {
            this.$refs.editCommentRef.showCommentDialog = true;
        },
        showReplyCommentDialog() {
            this.$refs.replyCommentRef.replyCommentDialog =  !this.$refs.replyCommentRef.replyCommentDialog;
        },
        getReviewByFilters(filter) {
            console.log(filter);
            this.filter = filter;
            this.getReviewList()
        },
        getReviewList() {
            this.toggleLoader(true);
            const successHandler = (response) => {
                this.toggleLoader(false);

                if (response.status === 200) {
                    console.log("res ", response.data);
                    this.reviewData = response.data.data;
                    this.heading = response.data.heading;
                    this.totalData=response.data.total_count
                }
            };

            const errorHandler = (error) => {
                this.showToast(
                    "Something went wrong internally!",
                    "error",
                    10000
                );
                console.log(error);
                this.toggleLoader(false);
            };

            const headers = {
                Authorization: `Bearer ${accessToken.getAccessToken()}`,
            };

            this.requestGET(
                `${API_URL.get_review}?page=${this.$refs.paginationRef.page}&data_per_page=${20}&filter=${this.filter}`,
                {},
                headers,
                successHandler,
                errorHandler
            );
        },
    },
};
</script>

<style scoped>
.back_button {
    color: #1f8f58;
    font-size: 0.9rem;
}
.heading {
    color: #919191;
    font-size: 1rem;
    transform: translateY(7px);
}
.filters > small {
    margin-left: 0.4rem;
    font-size: 1rem;
    color: #a5afa9;
    margin-bottom: 0.2rem;
    transform: translateX(-10px);
    cursor: pointer;
}
.active {
    color: black !important;
    text-decoration: underline;
    text-decoration-color: #1f8f58;
    text-decoration-thickness: 0.1rem;
    text-underline-offset: 4px;
}
.review_grid {
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 2px;
    background-color: white;
    width: 49%;
    justify-content: space-between;
    margin: 0.2rem;
    border-radius: 2px;
}
.review_list {
    padding: 0.6rem;
}
.review_list_img {
    height: 50px !important;
    object-fit: contain;
}
.star_icon {
    padding: 0.4rem;
    background-color: #fbfbf4;
}
.see_more_btn {
    font-size: 0.7rem;
    width: 50px;
    color: #1f8f58;
}
.description {
    font-size: 12px;
    color: #949494;
    white-space: normal;
    text-align: left;
    white-space: nowrap;
    text-align: left;
    text-overflow: ellipsis;
    overflow: hidden;
}
@media all and (max-width: 1060px) {
    .review_grid {
        grid-template-columns: none;
        grid-gap: 2px;
        background-color: white;
        width: 100%;
        justify-content: space-between;
        margin: 0.2rem;
        border-radius: 2px;
    }
}
</style>